import React from 'react'
import { useAppDispatch } from 'reduxTyped'
import { BtnV2, l, useToast } from '@manychat/manyui'

import * as builderStateActions from 'common/builder/actions/builderStateActions'
import { updateBuilderState } from 'common/builder/actions/updateBuilderState'
import { analyticsService } from 'utils/services/analytics'

interface TriggerPreActivatedAlertProps {
  builderId: string
  activationResult: Array<{ isActivated: boolean; triggerId: string }>
}

export const TriggerPreActivatedAlert = ({
  activationResult,
  builderId,
}: TriggerPreActivatedAlertProps) => {
  const isOneTriggerActivated =
    activationResult.filter((trigger) => trigger.isActivated).length === 1

  const dispatch = useAppDispatch()
  const { onClose } = useToast()

  const handleEditClick = () => {
    if (isOneTriggerActivated) {
      const activatedTrigger = activationResult.find((trigger) => trigger.isActivated)

      dispatch(builderStateActions.openTrigger(builderId, activatedTrigger?.triggerId))
      dispatch(updateBuilderState(builderId, { sidebarHidden: false }))
    } else {
      dispatch(
        updateBuilderState(builderId, {
          sidebarHidden: false,
          selectedNodes: {
            startingStep: true,
          },
        }),
      )
    }

    analyticsService.sendEvent('PUBLISH_TRIGGERS_PRE_ACTIVATION_RESULT.OPEN_SIDEBAR', {
      activationResult,
    })

    onClose()
  }

  return (
    <>
      <span>
        {isOneTriggerActivated &&
          l.translate(
            'Trigger has been turned on automatically. You can disable it in Trigger’s settings if you’d like to stop sending Automation to contacts.',
          )}

        {!isOneTriggerActivated &&
          l.translate(
            'Triggers have been turned on automatically. You can disable them anytime if you’d like to stop sending Automation to contacts.',
          )}
      </span>
      <BtnV2 onClick={handleEditClick} className="m-t">
        {isOneTriggerActivated && l.translate('Edit Trigger')}

        {!isOneTriggerActivated && l.translate('Edit Triggers')}
      </BtnV2>
    </>
  )
}
